import { HubSubscription } from "@axl/accel-framework/hub-client";

export class UserLogoutSubscription extends HubSubscription<void> {
    method = `UserLogout ${this.sessionId}`;

    constructor(public sessionId: string) {
        super();
    }
}